export const COMBO_TYPE = {
  SEQUENCE: 'S',
  PARALLEL: 'P',
} as const

export const COMBO_PRICE_TYPE = {
  SERVICE_PRICING: 'S',
  CUSTOM_PRICING: 'C',
} as const

export const COMBO_VARIANT = 'C'

export type ComboType = ValueOf<typeof COMBO_TYPE>
export type ComboPriceType = ValueOf<typeof COMBO_PRICE_TYPE>
